import { render, staticRenderFns } from "./RptAllDevActTot_BAK.vue?vue&type=template&id=b0d2ed14"
import script from "./RptAllDevActTot_BAK.vue?vue&type=script&lang=js"
export * from "./RptAllDevActTot_BAK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports